import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useMemo } from 'react';

import { bimWorkOrderChangeDefaultsGql } from '../bimWorkOrderChangeCreateOrEditQueries';

export const useWorkOrderChangeDefaults = (workOrderId: number, isCreating: boolean | undefined) => {
    const [resetBimWorkOrderChangeDefaultsData] = useResetStoreData({ requestId: 'bimWorkOrderChangeDefaults' });

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [bimWorkOrderChangeDefaultsData, bimWorkOrderChangeDefaultsStatus] = useRequest({
        requestId: 'bimWorkOrderChangeDefaults',
        query: bimWorkOrderChangeDefaultsGql,
        variables,
        withEffect: !!isCreating,
    });

    return useMemo(
        () => ({
            bimWorkOrderChangeDefaultsData,
            bimWorkOrderChangeDefaultsStatus,
            resetBimWorkOrderChangeDefaultsData,
        }),
        [bimWorkOrderChangeDefaultsData, bimWorkOrderChangeDefaultsStatus, resetBimWorkOrderChangeDefaultsData],
    );
};
